/**
 * User: hella
 * Date: 3/30/14
 * Time: 2:50 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

'use strict';

var browserCheck = require('bunsen/helpers/browserCheck');

module.exports = {
    timer: {
        count: 0,
        interval: 1000,
        fn: null
    },
    ie: {
        lessThan10: browserCheck.ie8() || browserCheck.ie9(),
        isIE9: browserCheck.ie9(),
        isIE8: browserCheck.ie8()
    },
    noop: function () { },
    disallowAction: function (e) {
        if (e) {
            e.preventDefault();
        }
        return false;
    },
    ieRedirect: function (url) {
        if (url) {
            global.location.href = url;
        }
    },
    goBack: function () {
        // this needs to be fixed to look at the document.referrer
        if (global.history && global.history.length > 1) {
            global.history.back();
        } else {
            this.ieRedirect(global.location.pathname);
        }
        return false;
    }
};




//////////////////
// WEBPACK FOOTER
// ./assets/js/global/mixins/commonjs/basicUtils.js
// module id = 71
// module chunks = 4 6 7 8 9 10 12 22 23 24 26 27 30 31 38 56 57